/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import Icon from '../Icon';
import { tokens, orange, inkA } from '../tokens';

// Numbered pager. Controlled via `page`/`onChange`, or self-managed if omitted.
const Pagination = ({ page, pageCount = 1, onChange }) => {
  const theme = useTheme();
  const t = tokens(theme);
  const [internal, setInternal] = useState(1);
  const current = page != null ? page : internal;
  const goTo = (n) => {
    if (onChange) onChange(n);
    if (page == null) setInternal(n);
  };
  const Btn = ({ children, active, disabled, onClick }) => (
    <button
      disabled={disabled}
      onClick={onClick}
      style={{
        minWidth: 34,
        height: 34,
        padding: '0 7px',
        borderRadius: 8,
        cursor: disabled ? 'default' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13.5px',
        fontWeight: 700,
        fontVariantNumeric: 'tabular-nums',
        background: active ? orange(0.1) : 'transparent',
        border: '1px solid ' + (active ? t.primary : inkA(theme, 0.12)),
        color: active
          ? t.primary
          : disabled
          ? inkA(theme, 0.25)
          : inkA(theme, 0.72),
        transition: 'background 120ms ease, border-color 120ms ease',
      }}
    >
      {children}
    </button>
  );
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        padding: '18px 0 20px',
      }}
    >
      <Btn
        disabled={current === 1}
        onClick={() => goTo(Math.max(1, current - 1))}
      >
        <Icon
          name="chevron-left"
          size={16}
          color={current === 1 ? inkA(theme, 0.25) : inkA(theme, 0.62)}
        />
      </Btn>
      {Array.from({ length: pageCount }, (_, i) => i + 1).map((n) => (
        <Btn key={n} active={current === n} onClick={() => goTo(n)}>
          {n}
        </Btn>
      ))}
      <Btn
        disabled={current === pageCount}
        onClick={() => goTo(Math.min(pageCount, current + 1))}
      >
        <Icon
          name="chevron-right"
          size={16}
          color={current === pageCount ? inkA(theme, 0.25) : inkA(theme, 0.62)}
        />
      </Btn>
    </div>
  );
};

export default Pagination;
